import React, { useEffect, useState } from 'react';
import { Image, Spin, Typography } from 'antd';
import request from '@/utils/request';

const COS_IMAGE_CACHE = new Map<string, string>();

export interface CosImageProps {
  cosKey?: string;
  url?: string;
  alt?: string;
  maxWidth?: number;
  maxHeight?: number;
}

export const CosImage: React.FC<CosImageProps> = ({
  cosKey,
  url: directUrl,
  alt,
  maxWidth = 320,
  maxHeight = 320,
}) => {
  const [url, setUrl] = useState<string | null>(
    directUrl ?? (cosKey ? COS_IMAGE_CACHE.get(cosKey) ?? null : null),
  );
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  useEffect(() => {
    if (url || !cosKey) return;
    let cancelled = false;
    setLoading(true);
    request
      .post<{ accessUrl: string }>('/cos/access-url', { cosKey })
      .then((res) => {
        if (cancelled) return;
        COS_IMAGE_CACHE.set(cosKey, res.data.accessUrl);
        setUrl(res.data.accessUrl);
      })
      .catch((e: Error) => {
        if (!cancelled) setErr(e?.message || '加载失败');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [cosKey, url]);

  if (loading) return <Spin size="small" />;
  if (err) {
    return (
      <Typography.Text type="danger" style={{ fontSize: 12 }}>
        图片加载失败 ({err})
      </Typography.Text>
    );
  }
  if (!url) {
    return (
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        [未提供 url 或 cosKey]
      </Typography.Text>
    );
  }
  return (
    <Image
      src={url}
      alt={alt || cosKey || 'image'}
      style={{ maxWidth, maxHeight, borderRadius: 4 }}
    />
  );
};

export default CosImage;
